import { SUM } from '__jsLibs/EXCEL';
const gettersTotalChangeInNetWorth30years = {
	CashFlow(state, getters) {
		return +state.constants['cash_flow'];
	},
	TaxSavings(state, getters) {
		return +state.constants['tax_savings'];
	},
	PrincipalPaydown(state, getters) {
		return +getters.LoanAmount;
	},
	Appreciation(state, getters) {
		return +state.constants['appreciation'];
	},
	TotalChangeInNetWorth30years(state, getters) {
		return SUM([
			+getters.CashFlow,
			+getters.TaxSavings,
			+getters.PrincipalPaydown,
			+getters.Appreciation
		]);
	},
	CashFlowPercent(state, getters) {
		return (100 * +state.constants['cash_flow']) / +getters.TotalChangeInNetWorth30years;
	},
	TaxSavingsPercent(state, getters) {
		return (100 * +state.constants['tax_savings']) / +getters.TotalChangeInNetWorth30years;
	},
	PrincipalPaydownPercent(state, getters) {
		return (100 * +getters.LoanAmount) / +getters.TotalChangeInNetWorth30years;
	},
	AppreciationPercent(state, getters) {
		return (100 * +state.constants['appreciation']) / +getters.TotalChangeInNetWorth30years;
	},
	InvestinginStockMarketAtBeforeTaxes(state, getters) {
		return +getters.TotalUpfrontInvestment * Math.pow(1 + +state.result['beat_roi_of'] / 100, +state.result['terms']) - +getters.TotalUpfrontInvestment;
	},
	RealEstateStockMarket(state, getters) {
		return +getters.TotalChangeInNetWorth30years - +getters.InvestinginStockMarketAtBeforeTaxes;
	},
	RequiredRateForStocksToMatch(state, getters) {
		const B8 = +getters.LoanAmount;
		const B23 = +getters.TotalUpfrontInvestment;
		const J28 = +state.constants['cash_flow'];
		const J29 = +state.constants['tax_savings'];
		const J30 = B8;
		const J31 = +state.constants['appreciation'];
		const J32 = +SUM([
			J28, J29, J30, J31
		]);

		const J35 = 100 * (Math.pow((J32 + B23) / B23, 1 / 30) - 1);
		return J35;
	},
	beat_roi_of(state, getters) {
		return +state.result['beat_roi_of'] / 100;
	}
};

export {
	gettersTotalChangeInNetWorth30years
};
